import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import '../App.css';

function Skills() {
  const { t } = useTranslation();

  const skills = [
    { category: t('programming_languages'), items: ["Python", "C++", "JavaScript", "SQL", "HTML/CSS", "Java"] },
    { category: t('tech_mid'), items: ["React", "Node.js", "Flask", "Bootstrap", "Tailwind"] },
    { category: "Tools", items: ["Git", "Docker", "AWS", "Linux", "MongoDB"] },
    { category: t('os'), items: ["Windows", "Linux", "MacOS", "Mikrotik"] }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 50 }
    }
  };

  return (
    <section id="skills" style={{ padding: 'var(--section-spacing) 0', position: 'relative' }}>
      <Container>
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t('skills')}
        </motion.h2>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row>
            {skills.map((skillGroup, index) => (
              <Col md={6} lg={3} key={index} className="mb-4">
                <motion.div
                  className="glass-card h-100"
                  variants={cardVariants}
                  whileHover={{
                    scale: 1.05,
                    rotateY: 5,
                    rotateX: 5,
                    boxShadow: "0 20px 40px rgba(0,0,0,0.2)"
                  }}
                  transition={{ type: "spring", stiffness: 300 }}
                  style={{ perspective: 1000 }}
                >
                  <h3 style={{
                    fontSize: '1.5rem',
                    marginBottom: '1.5rem',
                    color: 'var(--accent-primary)',
                    wordBreak: 'break-word', // Ensure long words break
                    hyphens: 'auto' // Add hyphens if supported
                  }}>
                    {skillGroup.category}
                  </h3>
                  <ul style={{ listStyle: 'none', padding: 0 }}>
                    {skillGroup.items.map((item, i) => (
                      <motion.li
                        key={i}
                        initial={{ opacity: 0, x: -10 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: i * 0.1 }}
                        style={{
                          marginBottom: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          color: 'var(--text-secondary)'
                        }}
                      >
                        <span style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          background: 'var(--accent-secondary)',
                          marginRight: '10px'
                        }}></span>
                        {item}
                      </motion.li>
                    ))}
                  </ul>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  );
}

export default Skills;
